import m from "../../es2015/themes/dark";
window.am4themes_dark = m;


//////////////////
// WEBPACK FOOTER
// ./themes/dark.js
// module id = null
// module chunks = 